import { FC, ReactNode, useState } from 'react';
import { Tooltip, IconButton, Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

export interface InfoButtonProps {
  tooltip: string;
  title: string;
  children: ReactNode;
  color?: string;
}

export const InfoButton: FC<InfoButtonProps> = ({ tooltip, title, children, color = 'primary.main' }) => {
  const [open, setOpen] = useState(false);

  const handleOpen = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Tooltip
        title={tooltip}
        placement="right"
        slotProps={{
          tooltip: {
            sx: { fontSize: 14 },
          },
        }}
      >
        <IconButton onClick={handleOpen} sx={{ color }}>
          <InfoIcon sx={{ fontSize: 18 }} />
        </IconButton>
      </Tooltip>
      <Dialog open={open} onClose={handleClose} aria-labelledby="info-dialog-title" maxWidth="sm" fullWidth>
        <DialogTitle id="info-dialog-title">{title}</DialogTitle>
        <DialogContent>{children}</DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary" variant="contained">
            Got it
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default InfoButton;
